<template>
    <v-layout fill-height column class="template-padding">
        <div v-for="(item, itemIndex) in items" :key="itemIndex">
            <template v-if="item.type == 'banner' && itemIndex == 0">
                <div :class="outerContainer" >
                    <v-img height="100%" :width="$vuetify.breakpoint.mdAndUp ? '100%' : ''" class="d-flex align-center mb-10" :src="item.image">
                        <div :class="$vuetify.breakpoint.mdAndUp ? 'h3 rubik font-weight-bold white--text text-center' : 'h4 rubik font-weight-bold white--text px-5 text-left'"
                            @focusout="editableData('banner', { element: 'heading' })" :contenteditable="editableContent"
                            v-html="item.heading"
                        >
                        </div>
                    </v-img>

                    <RowControls v-if="pageType == 'Canvas'" :rowIndex="itemIndex" />
                </div>
            </template>

            <template v-if="item.type == 'grids'">
                <Grid2 :item="item"
                    :index="itemIndex"
                    :styles="{
                        text: 'body font-weight-bold karla text-left',
                        image: {
                            contain: true,
                            wrapper: '',
                            class: '',
                            height: 'auto',
                            width: 'auto',
                            maxWidth: '100%',
                            maxHeight: '',
                            custom: {
                                margin: '0 auto'
                            }
                        },
                        heading1: {
                            wrapper: '',
                            classMobile: 'h4 rubik font-weight-bold white--text pa-5 debate-header1 responsive-heading',
                            classLarge: 'h4 rubik font-weight-bold white--text pa-5 debate-header1 responsive-heading',
                            after: '',
                            guideWrapper: '',
                            guideClass: 'ml-5'
                        },
                        heading2: {
                            wrapper: '',
                            classMobile: 'h4 rubik font-weight-bold white--text pa-5 debate-header2 responsive-heading',
                            classLarge: 'h4 rubik font-weight-bold white--text pa-5 debate-header2 responsive-heading',
                            after: '',
                            guideWrapper: '',
                            guideClass: 'ml-5'
                        },
                        textcard: {
                            outlined: false,
                            elevation: 0,
                            card: 'px-5 py-5 text-center',
                            text: 'h5 rubik font-weight-bold text-uppercase mt-3',
                            subtitle: 'body karla font-weight-bold'
                        },
                        imagecard: {
                            settings: {
                                colsImage: '',
                                colsText: ''
                            },
                            doubleCard: false,
                            elevation: 0,
                            outlined: false,
                            card: 'text-center pa-5',
                            imagePosition: 'top',
                            image: {
                                height: '',
                                width: ''
                            },
                            text: 'h5 rubik font-weight-bold mt-3',
                            subtitle: 'body karla font-weight-bold'
                        },
                        dialog: {
                            elevation: '',
                            cardClass: 'perfect-reading-box sb3 py-5 px-5 my-5',
                            cardColor: '',
                            innerCard: '',
                            dialogTitle: '',
                            dialogName: 'karla mt-5 mr-3 responsive-text',
                            textWrapper: 'text-left body karla h5 mt-5 responsive-text',
                            custom: {
                                text: '',
                                textClass: 'mt-5',
                            }
                        }
                    }"
                />
            </template>
        </div>

        <ImageUploader />
    </v-layout>
</template>

<script>
import RowControls from "@/components/RowControls.vue"
import ImageUploader from "@/components/ImageUploadModal.vue"
import { Grid2 } from "@/imports/elements.js"
import Vue from "vue"
import { highlights } from "@/mixins/highlights"

export default {
    props: ["items"],
    components: {
        RowControls, ImageUploader, Grid2
    },
    computed: {
        bannerTextSize () {
            return this.$vuetify.breakpoint.smAndDown ? "h4" : "h3"
        }
    },
    methods: {

    }
}
</script>
<style scoped>

.footer-container {
  background-color: #e9ecef;
}
</style>
